import { defineMessages } from 'react-intl';

import { ResetPasswordErrors } from '@/widgets/ResetPasswordErrorModal/config/types';

export const resetPasswordErrorModalTittleMessages =
  defineMessages<ResetPasswordErrors>({
    [ResetPasswordErrors.ExpiredTime]: {
      id: 'resetPassword.errors.expiredTime.title',
      defaultMessage: 'Error: Reset link expired.',
    },
  });

export const resetPasswordErrorModalMessages =
  defineMessages<ResetPasswordErrors>({
    [ResetPasswordErrors.ExpiredTime]: {
      id: 'resetPassword.errors.expiredTime.message',
      defaultMessage: 'Request a new one.',
    },
  });
